import { render } from "./ReportCardViewer.vue?vue&type=template&id=510a1154"
import script from "./ReportCardViewer.vue?vue&type=script&lang=js"
export * from "./ReportCardViewer.vue?vue&type=script&lang=js"

import "./ReportCardViewer.vue?vue&type=style&index=0&id=510a1154&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__